import { Session } from "@intech/react-service";
import { Col, Row } from "@intech/web-ui";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { UsuarioService } from "@services";
import { BaseAuth } from "../Base";

export const SelecionarMatricula: React.FC = () => {
  const history = useHistory();

  const [matriculas, setMatriculas] = useState<string[]>([]);

  useEffect(() => {
    (async () => {
      var matriculas = await UsuarioService.BuscarMatriculas();
      setMatriculas(matriculas);
    })();
  }, []);

  const selecionar = async (matricula: string) => {
    var login = await UsuarioService.SelecionarMatricula(matricula);
    await Session.setToken(login.AccessToken);
    await localStorage.setItem("pensionista", login.Pensionista.toString());

    await history.push("/");
  };

  return (
    <BaseAuth>
      <h5>
        <b>
          Encontramos mais de uma matrícula vinculada ao seu CPF. Para entrar no
          Portal favor selecionar uma opção abaixo:
        </b>
      </h5>

      <br />
      <br />

      {matriculas.map((matricula, index) => {
        return (
          <Row key={index} className={"mb-3"}>
            <Col>
              <div
                className="matricula-card"
                onClick={() => selecionar(matricula)}
              >
                <Row>
                  <Col>
                    <b>Matrícula: </b>
                    <label
                      style={{
                        fontSize: 15,
                      }}
                    >
                      {matricula}
                    </label>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        );
      })}
    </BaseAuth>
  );
};
